window.ONE_ANSWERS_DATA = [

  /* =========================================================
     START HERE
     ========================================================= */

  {
    id: "start.what_is_inline_figure_skating",
    title: "What inline figure skating is",
    category: "sport",
    question: "What is inline figure skating?",
    summary: "Inline figure skating is figure skating performed on inline skates rather than ice blades. It uses figure skating movement, technique and vocabulary on a wheeled setup.",
    facts: [
      "It can be used as a standalone skating discipline or as an additional training environment for ice skaters.",
      "Edges, turns, spins, jumps, footwork and programs can all be developed inline.",
      "The skating surface, wheel setup and frame geometry change how the movement feels compared with ice."
    ],
    related_items: [
      { id: "start.can_learn_without_ice", title: "Can I learn figure skating without an ice rink?" },
      { id: "learn.where_to_start", title: "Where should I start learning inline figure skating?" }
    ],
    related_pages: [
      {
        title: "What Is Inline Figure Skating?",
        url: "/blogs/inline-figure-skating-guides/what-is-inline-figure-skating-a-complete-guide-for-ice-skaters-and-beginners"
      },
      {
        title: "Explore ONE Academy",
        url: "/pages/academy"
      }
    ]
  },

  {
    id: "start.can_learn_without_ice",
    title: "Learning without an ice rink",
    category: "sport",
    question: "Can I learn figure skating without an ice rink?",
    summary: "Yes. Inline figure skating can provide a direct route into figure skating movement and technique when ice is unavailable.",
    facts: [
      "Inline figure skating can be the primary discipline rather than only a substitute for ice.",
      "A smooth, controlled skating area is important when learning.",
      "Structured progression matters more than rushing into advanced elements."
    ],
    related_items: [
      { id: "start.what_is_inline_figure_skating", title: "What inline figure skating is" },
      { id: "learn.where_to_start", title: "Where should I start learning inline figure skating?" }
    ],
    related_pages: [
      { title: "Start Learn to Skate", url: "/pages/learn-to-skate" },
      { title: "Explore ONE Academy", url: "/pages/academy" }
    ]
  },

  {
    id: "start.ice_vs_inline",
    title: "Ice skating and inline figure skating",
    category: "sport",
    question: "Is inline figure skating the same as ice figure skating?",
    summary: "No. The movement vocabulary is closely related, but wheels and ice create different surface feedback, grip, stopping behavior and equipment contact.",
    facts: [
      "Many figure skating movements can be trained in both environments.",
      "The feel is not identical and skaters should expect an adaptation period.",
      "Good inline training should support figure skating technique rather than encourage unnecessary compensations."
    ],
    related_items: [
      { id: "learn.transfer_to_ice", title: "Can inline training help my ice skating?" },
      { id: "learn.adaptation", title: "How long does it take to adapt to inline figure skates?" }
    ],
    related_pages: [
      {
        title: "Inline Figure Skating vs Ice Skating",
        url: "/blogs/inline-figure-skating-guides/inline-figure-skating-vs-ice-skating-what-transfers-and-what-doesnt"
      },
      { title: "Explore ONE Academy", url: "/pages/academy" }
    ]
  },


  /* =========================================================
     LEARNING + TECHNIQUE
     ========================================================= */

  {
    id: "learn.where_to_start",
    title: "Where to start",
    category: "technique",
    question: "Where should I start learning inline figure skating?",
    summary: "Start with basic skating position, balance, stopping and controlled forward movement before progressing into edges, turns, spins and jumps.",
    facts: [
      "ONE Academy Learn to Skate is organized as a 10-level, 49-lesson progression.",
      "You can follow the levels in order or return to the level that matches your current skating.",
      "New inline skaters should first become comfortable with wheels, grip and stopping even if they already skate on ice."
    ],
    related_items: [
      { id: "learn.adaptation", title: "How long does it take to adapt to inline figure skates?" },
      { id: "safety.first_session", title: "What should I practice in my first inline session?" }
    ],
    related_pages: [
      { title: "Start Learn to Skate", url: "/pages/learn-to-skate" },
      { title: "How to Use ONE Academy", url: "/pages/academy" }
    ]
  },

  {
    id: "learn.transfer_to_ice",
    title: "Inline training and ice skating",
    category: "technique",
    question: "Can inline training help my ice skating?",
    summary: "Inline training can add useful figure skating repetition away from the rink, especially for body position, edges, turns, spins, jumps and footwork.",
    facts: [
      "The two environments are related but not identical.",
      "Transfer depends on the skating task, equipment setup and surface.",
      "Inline training can complement ice training without replacing every ice-specific skill."
    ],
    related_items: [
      { id: "start.ice_vs_inline", title: "Ice skating and inline figure skating" },
      { id: "learn.adaptation", title: "How long does it take to adapt to inline figure skates?" }
    ],
    related_pages: [
      {
        title: "Can You Train Figure Skating Off Ice on Inline Skates?",
        url: "/blogs/inline-figure-skating-guides/can-you-train-figure-skating-off-ice-on-inline-skates"
      },
      { title: "Explore ONE Academy", url: "/pages/academy" }
    ]
  },

  {
    id: "learn.adaptation",
    title: "Adapting to inline figure skates",
    category: "technique",
    question: "How long does it take to adapt to inline figure skates?",
    summary: "There is no fixed adaptation time. Ice skaters should expect the first inline sessions to feel different while they learn the surface feedback, wheel grip and stopping behavior.",
    facts: [
      "Different does not automatically mean wrong.",
      "Start with basic balance, edges and direction changes before judging advanced elements.",
      "Progression should be based on control rather than a fixed number of sessions."
    ],
    related_items: [
      { id: "learn.where_to_start", title: "Where should I start learning inline figure skating?" },
      { id: "safety.first_session", title: "What should I practice in my first inline session?" }
    ],
    related_pages: [
      { title: "Start Learn to Skate", url: "/pages/learn-to-skate" }
    ]
  },

  {
    id: "learn.spins",
    title: "Learning spins",
    category: "technique",
    question: "How do I learn spins on inline figure skates?",
    summary: "Learn spins progressively rather than treating every spin as an isolated element. Build basic upright rotation first, then progress through the spin families.",
    facts: [
      "ONE Academy separates upright, sit, camel and flying spin families.",
      "Each lesson includes the element, coaching points and a practice progression.",
      "The spin libraries are designed to be revisited as your control develops."
    ],
    related_items: [
      { id: "learn.jumps", title: "How do I learn jumps on inline figure skates?" },
      { id: "learn.loops_turns", title: "How do I learn turns and loops?" }
    ],
    related_pages: [
      { title: "Explore Spins", url: "/pages/learn" },
      { title: "Learn Sit Spins", url: "/pages/sit-spins" },
      { title: "Learn Camel + Flying Spins", url: "/pages/camel-flying-spins" }
    ]
  },

  {
    id: "learn.jumps",
    title: "Learning jumps",
    category: "technique",
    question: "How do I learn jumps on inline figure skates?",
    summary: "Build jumps step by step from the takeoff, through the air and into a controlled landing rather than chasing height or rotation first.",
    facts: [
      "ONE Academy currently teaches the Waltz Jump, Salchow, Toe Loop, Loop Jump and Flip Jump.",
      "Jump lessons include takeoff positions, coaching points, progressions and landing work.",
      "Landing control should be established before increasing difficulty."
    ],
    related_items: [
      { id: "learn.spins", title: "How do I learn spins on inline figure skates?" },
      { id: "learn.off_skates", title: "Can I practice jump technique off-skates?" }
    ],
    related_pages: [
      { title: "Explore Jump Lessons", url: "/pages/jumps" },
      { title: "Explore Off-Skates Training", url: "/pages/off-skates-technique" }
    ]
  },

  {
    id: "learn.loops_turns",
    title: "Learning turns and loops",
    category: "technique",
    question: "How do I learn turns and loops on inline figure skates?",
    summary: "Turns and loops are built from edge control, body position, wheel position and timing. Learn each pattern individually before connecting them.",
    facts: [
      "ONE Academy currently includes Forward Outside, Forward Inside, Backward Outside and Backward Inside Loop lessons.",
      "Each loop uses a different relationship between the edge, body, free leg and arms.",
      "Practice both directions before combining elements."
    ],
    related_items: [
      { id: "learn.spins", title: "How do I learn spins on inline figure skates?" },
      { id: "geometry.center_zone", title: "Why does the center balance zone matter?" }
    ],
    related_pages: [
      { title: "Explore Turns + Loops", url: "/pages/turns-loops" },
      { title: "Start Learn to Skate", url: "/pages/learn-to-skate" }
    ]
  },

  {
    id: "learn.off_skates",
    title: "Off-skates training",
    category: "technique",
    question: "Can I practice figure skating technique off-skates?",
    summary: "Yes. Off-skates work can help you understand body position, jump patterns and movement before adding wheels or ice.",
    facts: [
      "Off-skates practice is a supporting training method, not a replacement for skating.",
      "It can reduce the number of things you are trying to understand at once.",
      "ONE Academy includes off-skates technique resources alongside on-skate lessons."
    ],
    related_items: [
      { id: "learn.jumps", title: "How do I learn jumps on inline figure skates?" }
    ],
    related_pages: [
      { title: "Explore Off-Skates Training", url: "/pages/off-skates-technique" },
      { title: "Explore ONE Academy", url: "/pages/academy" }
    ]
  },


  /* =========================================================
     GEOMETRY
     ========================================================= */

  {
    id: "geometry.balance_zones",
    title: "Balance zones",
    category: "geometry",
    question: "What are balance zones?",
    summary: "Balance zones describe the usable front, center and rear positions a figure skater moves through along the skating system.",
    facts: [
      "An ice blade creates three balance zones.",
      "Three wheels create two balance zones.",
      "Four wheels create three balance zones."
    ],
    related_items: [
      { id: "geometry.why_four_wheels", title: "Why does EDGE use four wheels?" },
      { id: "geometry.center_zone", title: "Why does the center balance zone matter?" }
    ],
    related_pages: [
      { title: "How EDGE Works", url: "/pages/edge" },
      {
        title: "Three Wheels vs Four Wheels",
        url: "/blogs/inline-figure-skating-guides/3-wheel-vs-4-wheel-inline-figure-skating-frames-whats-the-difference-and-why-it-matters"
      }
    ]
  },

  {
    id: "geometry.why_four_wheels",
    title: "Why EDGE uses four wheels",
    category: "geometry",
    question: "Why does EDGE use four wheels?",
    summary: "EDGE uses four wheels because four wheels create three balance zones: front, center and rear.",
    facts: [
      "Three wheels create two balance zones.",
      "Four wheels create three balance zones.",
      "The center balance zone on EDGE is on the center two wheels."
    ],
    related_items: [
      { id: "geometry.balance_zones", title: "What are balance zones?" },
      { id: "geometry.center_zone", title: "Why does the center balance zone matter?" }
    ],
    related_pages: [
      { title: "How EDGE Works", url: "/pages/edge" },
      {
        title: "Three Wheels vs Four Wheels",
        url: "/blogs/inline-figure-skating-guides/3-wheel-vs-4-wheel-inline-figure-skating-frames-whats-the-difference-and-why-it-matters"
      }
    ]
  },

  {
    id: "geometry.center_zone",
    title: "The center balance zone",
    category: "geometry",
    question: "Why does the center balance zone matter?",
    summary: "The center balance zone gives the skater a usable middle position on the center two wheels instead of forcing balance only toward the front or rear.",
    facts: [
      "Edges connect through the center.",
      "Turns, landings and traveling rotation all use controlled movement through the frame.",
      "On EDGE, the center balance position is on the center two wheels."
    ],
    related_items: [
      { id: "geometry.balance_zones", title: "What are balance zones?" },
      { id: "geometry.why_four_wheels", title: "Why does EDGE use four wheels?" }
    ],
    related_pages: [
      { title: "How EDGE Works", url: "/pages/edge" }
    ]
  },

  {
    id: "geometry.rocker_axles",
    title: "Rocker axles",
    category: "geometry",
    question: "What is a rocker axle?",
    summary: "A rocker axle lets the wheel position be adjusted so the skating profile can be changed without replacing the frame.",
    facts: [
      "EDGE uses independently adjustable rocker axles.",
      "Rocker axle adjustment changes how the wheels sit relative to one another.",
      "Make controlled changes and test the result rather than changing several settings at once."
    ],
    related_items: [
      { id: "setup.rocker_start", title: "Which rocker axle setting should I start with?" },
      { id: "geometry.balance_zones", title: "What are balance zones?" }
    ],
    related_pages: [
      { title: "How EDGE Works", url: "/pages/edge" },
      { title: "EDGE Setup and Support", url: "/pages/set-up" }
    ]
  },

  {
    id: "geometry.edge_pick",
    title: "EDGE pick",
    category: "geometry",
    question: "What is the EDGE pick?",
    summary: "The EDGE pick is the front contact used for pick-assisted figure skating actions on EDGE, including parts of spins, jump takeoffs and footwork.",
    facts: [
      "Pick height and wear affect when the pick reaches the skating surface.",
      "The EDGE pick is adjusted as part of setup and maintenance.",
      "The pick should be used according to the element being practiced rather than carried as unnecessary weight through the front of the frame."
    ],
    related_items: [
      { id: "geometry.edge_plug", title: "What is the EDGE plug?" },
      { id: "setup.pick_height", title: "How do I check EDGE pick height?" }
    ],
    related_pages: [
      { title: "EDGE Setup and Support", url: "/pages/set-up" },
      { title: "How EDGE Works", url: "/pages/edge" }
    ]
  },

  {
    id: "geometry.edge_plug",
    title: "EDGE plug",
    category: "geometry",
    question: "What is the EDGE plug?",
    summary: "The EDGE plug is the pick-free option for EDGE when the skater wants to use the frame without an EDGE pick.",
    facts: [
      "Using an EDGE plug removes the pick contact from the front of the frame.",
      "Pick-free skating changes which pick-assisted actions are available.",
      "Choose the EDGE pick or EDGE plug according to the skating you intend to do."
    ],
    related_items: [
      { id: "geometry.edge_pick", title: "What is the EDGE pick?" }
    ],
    related_pages: [
      { title: "How EDGE Works", url: "/pages/edge" },
      { title: "EDGE Setup and Support", url: "/pages/set-up" }
    ]
  },


  /* =========================================================
     EQUIPMENT
     ========================================================= */

  {
    id: "equipment.what_is_edge",
    title: "What EDGE is",
    category: "equipment",
    question: "What is EDGE™?",
    summary: "EDGE™ | Inline Figure Skating System is ONE Blades' inline figure skating system for training edges, turns, spins, jumps and pairs away from the rink.",
    facts: [
      "EDGE mounts to compatible figure skating boots.",
      "The system is built around four wheels, three balance zones and independently adjustable rocker axles.",
      "The complete product includes the components listed on the live EDGE product page."
    ],
    related_items: [
      { id: "geometry.why_four_wheels", title: "Why does EDGE use four wheels?" },
      { id: "equipment.choose_frame", title: "How do I choose an inline figure skating frame?" }
    ],
    related_pages: [
      { title: "Explore EDGE", url: "/products/edge" },
      { title: "How EDGE Works", url: "/pages/edge" }
    ]
  },

  {
    id: "equipment.choose_frame",
    title: "Choosing an inline figure skating frame",
    category: "equipment",
    question: "How do I choose an inline figure skating frame?",
    summary: "Choose from the skating you want to do, then compare geometry, wheel count, rocker adjustment, pick system, sizing, wheel options and what is included.",
    facts: [
      "Do not choose from price or appearance alone.",
      "The frame should fit the physical sole length of the boot.",
      "The complete setup matters more than any single specification."
    ],
    related_items: [
      { id: "geometry.balance_zones", title: "What are balance zones?" },
      { id: "sizing.edge_size", title: "How do I choose my EDGE size?" }
    ],
    related_pages: [
      {
        title: "How to Choose the Right Inline Figure Skating Frame",
        url: "/blogs/inline-figure-skating-guides/how-to-choose-the-right-inline-figure-skating-frame"
      },
      {
        title: "PIC Skate vs Snow White vs ONE Blades EDGE",
        url: "/blogs/inline-figure-skating-guides/pic-skate-vs-snow-white-vs-one-blades-edge-honest-comparison"
      }
    ]
  },

  {
    id: "equipment.normal_inline_skates",
    title: "Recreational skates and figure skating",
    category: "equipment",
    question: "Can I use normal inline skates for figure skating?",
    summary: "Normal recreational inline skates are built for general skating, while inline figure skating systems are designed around figure skating movement and contact points.",
    facts: [
      "A recreational setup may not provide the same rocker, balance positions or pick contact used in figure skating.",
      "What you can practice depends on the geometry and configuration of the skate.",
      "Use equipment that matches the type of skating you are trying to learn."
    ],
    related_items: [
      { id: "equipment.choose_frame", title: "How do I choose an inline figure skating frame?" },
      { id: "start.what_is_inline_figure_skating", title: "What inline figure skating is" }
    ],
    related_pages: [
      {
        title: "How to Choose the Right Inline Figure Skating Frame",
        url: "/blogs/inline-figure-skating-guides/how-to-choose-the-right-inline-figure-skating-frame"
      }
    ]
  },

  {
    id: "equipment.what_is_included",
    title: "What comes with EDGE",
    category: "equipment",
    question: "What comes with EDGE?",
    summary: "EDGE is sold as a complete inline figure skating system rather than a frame-only purchase. Check the live product page for the current contents.",
    facts: [
      "The live EDGE product page is the source of truth for current included components.",
      "Sizing, wheel configuration and available options should also be checked on the live store.",
      "Product contents can change, so do not rely on old posts or third-party descriptions."
    ],
    related_items: [
      { id: "equipment.what_is_edge", title: "What is EDGE™?" },
      { id: "sizing.edge_size", title: "How do I choose my EDGE size?" }
    ],
    related_pages: [
      { title: "Explore EDGE", url: "/products/edge" }
    ]
  },

  {
    id: "equipment.wheels",
    title: "Indoor and outdoor wheels",
    category: "equipment",
    question: "Which wheels should I use with EDGE?",
    summary: "Use the wheel setup designed for the skating surface. ONE Blades uses different dual-durometer pairings for indoor and outdoor skating.",
    facts: [
      "Indoor: 82A outer and 85A inner.",
      "Outdoor: 85A outer and 82A inner.",
      "The pairing is part of one dual-durometer wheel construction, not two separate wheels."
    ],
    related_items: [
      { id: "surface.indoor", title: "What is a good indoor skating surface?" },
      { id: "surface.outdoor", title: "Where can I skate outside?" }
    ],
    related_pages: [
      { title: "Explore EDGE", url: "/products/edge" },
      { title: "Inline Figure Skating Guides", url: "/blogs/inline-figure-skating-guides" }
    ]
  },

  {
    id: "equipment.bearings",
    title: "Bearings",
    category: "equipment",
    question: "Do bearings matter for inline figure skating?",
    summary: "Yes. Bearings affect how consistently the wheels roll and should be kept clean, dry and free from damage.",
    facts: [
      "Noise, roughness, drag or uneven rolling are reasons to inspect a bearing.",
      "Water and grit shorten bearing life.",
      "Bearing maintenance is separate from rocker axle adjustment."
    ],
    related_items: [
      { id: "setup.bearing_change", title: "How do I change EDGE bearings?" },
      { id: "setup.after_skate", title: "What should I check after skating?" }
    ],
    related_pages: [
      { title: "EDGE Setup and Support", url: "/pages/set-up" }
    ]
  },


  /* =========================================================
     SIZING
     ========================================================= */

  {
    id: "sizing.edge_size",
    title: "Choosing the correct EDGE size",
    category: "sizing",
    question: "How do I choose my EDGE size?",
    summary: "Measure the physical sole length of your figure skating boot from heel to toe in millimeters. The physical boot measurement decides the order.",
    facts: [
      "Do not use everyday shoe size to choose the frame.",
      "The sizing finder can be used as a cross-check.",
      "If an estimated database measurement and the boot in front of you disagree, trust the physical boot measurement."
    ],
    related_items: [
      { id: "setup.mounting", title: "How do I mount EDGE?" },
      { id: "equipment.what_is_edge", title: "What is EDGE™?" }
    ],
    related_pages: [
      { title: "Find Your EDGE Size", url: "/pages/sizing-guide" },
      { title: "Explore EDGE", url: "/products/edge" }
    ]
  },


  /* =========================================================
     SETUP + MAINTENANCE
     ========================================================= */

  {
    id: "setup.mounting",
    title: "Mounting EDGE",
    category: "setup",
    question: "How do I mount EDGE?",
    summary: "Mounting starts with measured front and rear center references on the boot, controlled drilling and an initial alignment test before the mount is finalized.",
    facts: [
      "Measure the center rather than judging it by eye.",
      "Follow the current EDGE mounting guide for drill size, hardware and screw sequence.",
      "Test the initial alignment before completing the final mount."
    ],
    related_items: [
      { id: "setup.alignment", title: "How do I center EDGE under the boot?" },
      { id: "sizing.edge_size", title: "How do I choose my EDGE size?" }
    ],
    related_pages: [
      { title: "EDGE Setup and Support", url: "/pages/set-up" }
    ]
  },

  {
    id: "setup.alignment",
    title: "EDGE alignment",
    category: "setup",
    question: "How do I center EDGE under the boot?",
    summary: "Find measured front and rear center references on the boot sole and use those references to position the frame before drilling.",
    facts: [
      "A measured center reference is more reliable than visual guessing.",
      "The first skate test is used to confirm whether placement feels correct.",
      "Do not complete the final mount before checking alignment."
    ],
    related_items: [
      { id: "setup.mounting", title: "How do I mount EDGE?" }
    ],
    related_pages: [
      { title: "EDGE Setup and Support", url: "/pages/set-up" }
    ]
  },

  {
    id: "setup.rocker_start",
    title: "Starting rocker axle setup",
    category: "setup",
    question: "Which rocker axle setting should I start with?",
    summary: "Start conservatively, test basic balance and edge control, then make one controlled rocker axle change at a time.",
    facts: [
      "Changing several rocker axles at once makes the result harder to understand.",
      "Your skating background and the elements you are practicing should influence later adjustment.",
      "Use the current setup guide when changing rocker axle positions."
    ],
    related_items: [
      { id: "geometry.rocker_axles", title: "What is a rocker axle?" }
    ],
    related_pages: [
      { title: "EDGE Setup and Support", url: "/pages/set-up#understand-rocker-axles" },
      { title: "How EDGE Works", url: "/pages/edge#edge-rocker-axles" }
    ]
  },

  {
    id: "setup.pick_height",
    title: "EDGE pick height",
    category: "setup",
    question: "How do I check EDGE pick height?",
    summary: "EDGE pick height should be checked as part of setup so the pick contacts the surface when needed without interfering unnecessarily with normal skating.",
    facts: [
      "Pick position affects when the pick reaches the floor.",
      "Wear changes the contact point over time.",
      "Use the current EDGE setup guide for the adjustment and test process."
    ],
    related_items: [
      { id: "geometry.edge_pick", title: "What is the EDGE pick?" },
      { id: "setup.after_skate", title: "What should I check after skating?" }
    ],
    related_pages: [
      { title: "EDGE Setup and Support", url: "/pages/set-up" }
    ]
  },

  {
    id: "setup.after_skate",
    title: "After-skate maintenance",
    category: "setup",
    question: "What should I check after skating?",
    summary: "Check the wheels, bearings, EDGE picks, rocker axles and mounting hardware for wear, looseness, dirt or damage before the next session.",
    facts: [
      "Dry the setup after exposure to moisture.",
      "Remove debris before it works into moving parts.",
      "Small maintenance checks are easier than diagnosing a neglected setup later."
    ],
    related_items: [
      { id: "equipment.bearings", title: "Do bearings matter for inline figure skating?" },
      { id: "setup.bearing_change", title: "How do I change EDGE bearings?" }
    ],
    related_pages: [
      { title: "EDGE Setup and Support", url: "/pages/set-up" }
    ]
  },

  {
    id: "setup.bearing_change",
    title: "Changing bearings",
    category: "setup",
    question: "How do I change EDGE bearings?",
    summary: "Remove the wheel, replace the bearing assembly as shown in the current setup guide, then reinstall and check that the wheel rolls consistently.",
    facts: [
      "Do not continue skating on a damaged or rough-running bearing.",
      "Keep the bearing area clean while servicing it.",
      "Confirm the wheel spins freely after reassembly."
    ],
    related_items: [
      { id: "equipment.bearings", title: "Do bearings matter for inline figure skating?" },
      { id: "setup.after_skate", title: "What should I check after skating?" }
    ],
    related_pages: [
      { title: "EDGE Setup and Support", url: "/pages/set-up" }
    ]
  },


  /* =========================================================
     SURFACES
     ========================================================= */

  {
    id: "surface.indoor",
    title: "Indoor skating surfaces",
    category: "surface",
    question: "What is a good indoor surface for inline figure skating?",
    summary: "A hard, smooth and clean sports hall or roller-rink style floor gives a controlled environment for technical practice.",
    facts: [
      "A smooth surface makes balance, alignment and technique easier to read.",
      "The floor still needs enough usable grip for the element being practiced.",
      "Inspect the surface before skating even when it is indoors."
    ],
    related_items: [
      { id: "equipment.wheels", title: "Which wheels should I use with EDGE?" },
      { id: "surface.inspect", title: "What should I check before skating?" }
    ],
    related_pages: [
      { title: "Inline Figure Skating Guides", url: "/blogs/inline-figure-skating-guides" }
    ]
  },

  {
    id: "surface.outdoor",
    title: "Outdoor skating surfaces",
    category: "surface",
    question: "Where can I skate outside?",
    summary: "Look for a smooth, clean and predictable surface with enough space. Well-maintained courts and smooth concrete can work well.",
    facts: [
      "Avoid gravel, loose debris, severe cracks and unpredictable traffic.",
      "Surface quality affects control, vibration and wheel behavior.",
      "Outdoor conditions can change during a session, so keep checking the area."
    ],
    related_items: [
      { id: "equipment.wheels", title: "Which wheels should I use with EDGE?" },
      { id: "surface.inspect", title: "What should I check before skating?" }
    ],
    related_pages: [
      { title: "Inline Figure Skating Guides", url: "/blogs/inline-figure-skating-guides" }
    ]
  },

  {
    id: "surface.inspect",
    title: "Surface inspection",
    category: "surface",
    question: "What should I check before skating?",
    summary: "Check the area for stones, moisture, cracks, dirt, surface contamination, traffic and anything else that could unexpectedly stop a wheel or reduce grip.",
    facts: [
      "Small debris can matter because inline wheels have direct rolling contact with the surface.",
      "A surface that was clear earlier may change during the session.",
      "Do not begin technical practice until the skating area is controlled."
    ],
    related_items: [
      { id: "safety.environment", title: "Is inline figure skating safe?" },
      { id: "surface.outdoor", title: "Where can I skate outside?" }
    ],
    related_pages: [
      {
        title: "Safety Guide",
        url: "/blogs/inline-figure-skating-guides/the-safety-guide-how-to-train-inline-without-getting-hurt"
      }
    ]
  },


  /* =========================================================
     SAFETY
     ========================================================= */

  {
    id: "safety.environment",
    title: "Inline skating safety",
    category: "safety",
    question: "Is inline figure skating safe?",
    summary: "Inline figure skating has risk like any skating activity. Good progression, suitable equipment and a controlled skating environment reduce avoidable risk.",
    facts: [
      "Surface quality, debris, traffic and space matter.",
      "Do not attempt elements beyond your current control because you are experienced on ice.",
      "Protective equipment can reduce the consequences of a fall but does not replace progression."
    ],
    related_items: [
      { id: "safety.protection", title: "What protective equipment should I wear?" },
      { id: "safety.first_session", title: "What should I practice in my first inline session?" }
    ],
    related_pages: [
      {
        title: "Safety Guide",
        url: "/blogs/inline-figure-skating-guides/the-safety-guide-how-to-train-inline-without-getting-hurt"
      }
    ]
  },

  {
    id: "safety.protection",
    title: "Protective equipment",
    category: "safety",
    question: "What protective equipment should I wear?",
    summary: "Protection should match the skater, the environment and the difficulty of the skating. A helmet, wrist guards and knee protection are common options.",
    facts: [
      "More protection can be useful during early adaptation or higher-risk practice.",
      "Protection does not make an unsuitable surface safe.",
      "Skaters should choose protection based on their own circumstances rather than assuming one setup suits everyone."
    ],
    related_items: [
      { id: "safety.environment", title: "Is inline figure skating safe?" },
      { id: "safety.first_session", title: "What should I practice in my first inline session?" }
    ],
    related_pages: [
      {
        title: "Safety Guide",
        url: "/blogs/inline-figure-skating-guides/the-safety-guide-how-to-train-inline-without-getting-hurt"
      }
    ]
  },

  {
    id: "safety.first_session",
    title: "First inline session",
    category: "safety",
    question: "What should I practice in my first inline session?",
    summary: "Use the first session to understand balance, rolling, stopping and basic direction changes before adding spins, jumps or faster sequences.",
    facts: [
      "Ice experience helps, but wheels still require adaptation.",
      "Begin on a smooth, controlled surface.",
      "Move forward only when the basic skating feels predictable."
    ],
    related_items: [
      { id: "learn.where_to_start", title: "Where should I start learning inline figure skating?" },
      { id: "learn.adaptation", title: "How long does it take to adapt to inline figure skates?" }
    ],
    related_pages: [
      { title: "Start Learn to Skate", url: "/pages/learn-to-skate" },
      {
        title: "Safety Guide",
        url: "/blogs/inline-figure-skating-guides/the-safety-guide-how-to-train-inline-without-getting-hurt"
      }
    ]
  },


  /* =========================================================
     CREATOR PLATFORM
     ========================================================= */

  {
    id: "creator.how_it_works",
    title: "How the Creator Platform works",
    category: "creator",
    question: "How does the ONE Blades Creator Platform work?",
    summary: "EDGE owners can join, receive a personal creator link, share their genuine experience and earn commission from eligible attributed purchases.",
    facts: [
      "Customers pay the normal ONE retail price.",
      "The standard creator rate is 10%.",
      "The standard creator rate is 10%."
    ],
    related_items: [
      { id: "creator.who_can_join", title: "Who can join the Creator Platform?" },
      { id: "creator.rules", title: "What rules do creators need to follow?" }
    ],
    related_pages: [
      { title: "Creator Platform", url: "/pages/creator-platform" },
      { title: "Meet the Creators", url: "/pages/meet-the-creators" }
    ]
  },

  {
    id: "creator.who_can_join",
    title: "Who can join",
    category: "creator",
    question: "Who can join the ONE Blades Creator Platform?",
    summary: "The Creator Platform is open to ONE Blades EDGE owners.",
    facts: [
      "There is no future automatic tier progression.",
      "The platform does not use progression ladders or performance thresholds.",
      "Creators receive a personal link after joining."
    ],
    related_items: [
      { id: "creator.how_it_works", title: "How does the ONE Blades Creator Platform work?" },
      { id: "creator.rules", title: "What rules do creators need to follow?" }
    ],
    related_pages: [
      { title: "Creator Platform", url: "/pages/creator-platform" },
      { title: "Creator Rules", url: "/pages/creator-rules" }
    ]
  },

  {
    id: "creator.customer_discount",
    title: "Creator links and retail price",
    category: "creator",
    question: "Does a creator link change the retail price?",
    summary: "Normal retail price when they buy through an eligible ONE Blades creator link.",
    facts: [
      "The standard creator rate is 10% on attributable ONE direct-to-consumer sales. Customers receive no creator discount.",
      "Current platform rules should always be checked on the live Creator Platform.",
      "Creators should explain the relationship clearly when sharing their link."
    ],
    related_items: [
      { id: "creator.how_it_works", title: "How does the ONE Blades Creator Platform work?" },
      { id: "creator.rules", title: "What rules do creators need to follow?" }
    ],
    related_pages: [
      { title: "Creator Platform", url: "/pages/creator-platform" },
      { title: "Creator Rules", url: "/pages/creator-rules" }
    ]
  },

  {
    id: "creator.creator_earning",
    title: "Creator earnings",
    category: "creator",
    question: "How much does a ONE Blades creator earn?",
    summary: "The standard creator rate is 10% commission from eligible attributed purchases.",
    facts: [
      "The standard creator rate is 10%.",
      "There is no future sales-based commission progression.",
      "Eligibility and attribution rules are defined by the live Creator Platform."
    ],
    related_items: [
      { id: "creator.how_it_works", title: "How does the ONE Blades Creator Platform work?" },
      { id: "creator.rules", title: "What rules do creators need to follow?" }
    ],
    related_pages: [
      { title: "Creator Platform", url: "/pages/creator-platform" }
    ]
  },

  {
    id: "creator.rules",
    title: "Creator rules",
    category: "creator",
    question: "What rules do ONE Blades creators need to follow?",
    summary: "Creator rules are built around disclosure, accuracy, safety, privacy and honest personal experience.",
    facts: [
      "Creators must not invent results, specifications, pricing, availability or product claims.",
      "The live ONE Blades store is the source of truth for current product information.",
      "Creators are independent participants and should not present themselves as ONE Blades employees or official spokespeople."
    ],
    related_items: [
      { id: "creator.how_it_works", title: "How does the ONE Blades Creator Platform work?" },
      { id: "creator.who_can_join", title: "Who can join the Creator Platform?" }
    ],
    related_pages: [
      { title: "Creator Rules", url: "/pages/creator-rules" },
      { title: "Creator Starter Guide", url: "/pages/creator-starter-guide" }
    ]
  }

];